import { ReactElement, useEffect, useState } from 'react';
import Header, { IBreadcrumbProps } from '../../components/Header/Header';
import axios from 'axios';
import { Navigate } from 'react-router-dom';

interface IMainProps {
  children: ReactElement;
  breadcrumb?: IBreadcrumbProps[];
  actions?: ReactElement;
}

const Main = ({ children, breadcrumb, actions }: IMainProps) => {
  const [isConnected, setIsConnected] = useState<boolean | null>(null);

  useEffect(() => {
    axios
      .get('/api/account/', { withCredentials: true })
      .then((response: any) => {
        setIsConnected(response.data.connected);
      })
      .catch((err) => {
        setIsConnected(false);
      });
  }, []);

  return (
    <>
      {isConnected === false && <Navigate to="/login" />}
      {isConnected === true && (
        <>
          <Header breadcrumb={breadcrumb} actions={actions} />
          {children}
        </>
      )}
    </>
  );
};

export default Main;
